/**
 * In-app nudge when pantry is low and no recipes match pantry mode.
 * Parent controls visibility (server rules).
 */
export default function LowPantryShoppingBanner({ onGoShopping }) {
  return (
    <div
      className="page-alert-warning low-pantry-shopping-banner"
      role="status"
      aria-live="polite"
    >
      <p className="low-pantry-shopping-banner-title">
        Your pantry is low.
      </p>
      <p className="low-pantry-shopping-banner-body">
        You are low on pantry items and none of your saved recipes match what you have on hand right now.
      </p>
      {onGoShopping && (
        <div className="low-pantry-shopping-banner-actions">
          <button type="button" className="primary" onClick={onGoShopping}>
            Open Shop
          </button>
        </div>
      )}
    </div>
  )
}
